import { render, staticRenderFns } from "./OpinionPersonalAdd.vue?vue&type=template&id=cc9c212a&scoped=true"
import script from "./OpinionPersonalAdd.vue?vue&type=script&lang=js"
export * from "./OpinionPersonalAdd.vue?vue&type=script&lang=js"
import style0 from "./OpinionPersonalAdd.vue?vue&type=style&index=0&id=cc9c212a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9c212a",
  null
  
)

export default component.exports